export const translations = {
  ar: {
    selectAll: "تحديد الكل",
    deselectAll: "إلغاء تحديد الكل",
    includeAllFeatures: "تفعيل كل الميزات لهذه الصفحات أيضاً",
    pageTitle: "إدارة المستويات الإدارية",
    createAdminLevel: "إنشاء مستوى إداري",
    refreshPermissions: "تحديث الأذونات",
    selectCompany: "اختر الشركة",
    clientName: "اسم العميل",
    workingCompany: "الشركة العاملة",
    selectClient: "اختر العميل...",
    selectCompany2: "اختر الشركة...",
    loadAdminLevels: "تحميل المستويات الإدارية",
    loadDrive: "تحميل المحرك",
    loadingCompanies: "جاري تحميل الشركات...",
    adminLevels: "المستويات الإدارية",
    loading: "جاري التحميل...",
    noAdminLevels: "لا توجد مستويات إدارية للشركة المحددة",
    visibilityControl: "التحكم في الرؤية",
    assignEmployees: "تعيين الموظفين",
    modulesFeatures: "الوحدات والميزات",
    addModule: "إضافة وحدة",
    noModules: "لا توجد وحدات معينة",
    addFeature: "إضافة ميزة",
    noFeatures: "لا توجد ميزات مكونة",
    name: "الاسم",
    description: "الوصف",
    create: "إنشاء",
    cancel: "إلغاء",
    save: "حفظ",
    selectModule: "اختر وحدة",
    selectModulePlaceholder: "-- اختر وحدة --",
    selectFeature: "اختر ميزة",
    selectFeaturePlaceholder: "-- اختر ميزة --",
    visibilityControlTitle: "التحكم في الرؤية",
    visibilityDesc: "تكوين من يمكن لهذا المستوى الإداري مشاهدته.",
    searchUsers: "البحث عن المستخدمين...",
    loadingVisibility: "جاري تحميل قواعد الرؤية...",
    companies: "1) الشركات",
    noCompanies: "لا توجد شركات لهذا العميل.",
    departments: "2) الأقسام",
    selectAtLeastOne: "اختر شركة واحدة على الأقل.",
    noDepartments: "لم يتم تحميل أي أقسام.",
    departmentTip: "تلميح: إذا اخترت أقساماً لشركة، فهذا يعني جميع المستخدمين في تلك الأقسام.",
    users: "3) المستخدمون (اختياري)",
    usersTip: "إذا كنت تريد مستخدمين محددين فقط، اترك الأقسام غير محددة.",
    noUsers: "لم يتم العثور على مستخدمين.",
    assignToLevel: "تعيين موظفين للمستوى",
    assignDesc: "سيؤدي اختيار المستخدمين هنا إلى تعيين مستواهم الإداري إلى",
    searchByName: "البحث بالاسم/البريد/القسم...",
    loadingUsers: "جاري تحميل المستخدمين...",
    saveAssignments: "حفظ التعيينات",
    deleteConfirm: "هل أنت متأكد من حذف هذا المستوى الإداري؟",
    deleteMessage: "سيتم حذف هذا المستوى الإداري بشكل نهائي ولا يمكن التراجع عنه.",
    deleteLevelBtn: "حذف المستوى",
    assignedUsersCount: "مستخدم معيّن",
    created: "تم إنشاء المستوى الإداري بنجاح!",
    moduleUpdated: "تم تحديث صلاحية الوحدة!",
    featureUpdated: "تم تحديث صلاحية الميزة!",
    deleted: "تم حذف المستوى الإداري بنجاح!",
    moduleAdded: "تم إضافة الوحدة بنجاح!",
    featureAdded: "تم إضافة الميزة بنجاح!",
    visibilitySaved: "تم حفظ قواعد الرؤية!",
    assignmentsSaved: "تم تعيين المستخدمين للمستوى!",
    selectModuleError: "الرجاء اختيار وحدة",
    selectFeatureError: "الرجاء اختيار ميزة",
    namePlaceholder: "مثال: مدير الموارد البشرية",
    descPlaceholder: "وصف مختصر لهذا المستوى الإداري",
    welcomeTitle: "مرحباً بك في إدارة المستويات الإدارية",
    welcomeSubtitle: "أدر الأدوار والصلاحيات والوصول للموظفين بكفاءة",
    infoModalTitle: "إدارة المستويات الإدارية",
    infoModalDesc: "تتيح لك هذه الصفحة:\n• إنشاء وإدارة المستويات الإدارية\n• تعيين الصلاحيات والميزات\n• التحكم في إعدادات الرؤية\n• تعيين الموظفين\n• تحرير أو إزالة التكوينات الموجودة",
    // ── per-user permission editor (v2) ──
    usersTab: "المستخدمون",
    levelsTab: "المستويات",
    teamMembers: "أعضاء الفريق",
    noUsersLoaded: "حمّل شركة لعرض مستخدميها",
    noSearchResults: "لا يوجد مستخدمون مطابقون",
    selectUserPrompt: "اختر مستخدماً لضبط صلاحياته",
    selectUserHint: "اختر أحد أعضاء الفريق من القائمة لعرض الصفحات والميزات المتاحة له وتعديلها.",
    selectLevelPrompt: "اختر مستوى لضبط صلاحياته",
    selectLevelHint: "اختر مستوى من القائمة لعرض الصفحات والميزات المتاحة له وتعديلها. تنطبق التغييرات على جميع المستخدمين المعيّنين على هذا المستوى.",
    customSetup: "إعداد مخصص",
    inheritsPrefix: "يتبع مستوى",
    noLevelYet: "بدون مستوى",
    pagesTitle: "الصفحات والصلاحيات",
    changesSaveInstantly: "تُحفَظ التغييرات فوراً",
    stateHidden: "مخفي",
    stateLocked: "ظاهر · مقفل",
    stateFull: "وصول كامل",
    stateHiddenHint: "تُزال الصفحة تماماً من القوائم.",
    stateLockedHint: "تظهر في القائمة، لكنها تفتح شاشة «لا يوجد وصول».",
    stateFullHint: "تفتح بشكل طبيعي — يمكنك ضبط الأزرار والأعمدة بالأسفل.",
    featuresButtons: "الأزرار",
    featuresSections: "الأقسام",
    featuresTabs: "التبويبات",
    columnsTitle: "أعمدة الجداول",
    columnsHint: "الشريحة الممتلئة = عمود ظاهر. اضغط على العمود لإخفائه.",
    noFeaturesForPage: "لا توجد خيارات تفصيلية لهذه الصفحة.",
    previewTitle: "معاينة مباشرة",
    webPreview: "القائمة الجانبية للويب",
    mobilePreview: "معاينة الجوال",
    dashboardLabel: "الرئيسية",
    settingsLabel: "الإعدادات",
    lockedTag: "مقفل",
    confirmPersonalTitle: "إنشاء إعداد شخصي؟",
    confirmPersonalBefore: "ينتمي حالياً إلى المستوى المشترك",
    confirmPersonalAfter: "المتابعة ستؤدي إلى إزالة هذا المستخدم من ذلك المستوى وتحويله إلى إعداد شخصي خاص به، منسوخ منه كنقطة بداية.",
    continueBtn: "متابعة",
    personalLevelReady: "الإعداد الشخصي جاهز!",
    permissionSaved: "تم حفظ التغيير!",
    permissionFailed: "تعذر حفظ التغيير — تم التراجع عنه.",
    loadingConfig: "جاري تحميل الإعدادات...",
    loadingRegistry: "جاري تحميل قائمة الصفحات...",
    registryFailed: "تعذر تحميل قائمة الصفحات.",
    usersFailed: "تعذر تحميل المستخدمين.",
    personalLevelFailed: "تعذر تجهيز الإعداد الشخصي.",
    usersCount: "مستخدم",
    configuringFor: "إعدادات",
    // ── remove admin level ──
    removeAdminLevelBtn: "إزالة المستوى الإداري",
    removeLevelTitle: "إزالة المستوى الإداري؟",
    removeLevelBody: "سيفقد صلاحيات العرض الإدارية بالكامل وسيعود إلى الوصول الاعتيادي.",
    removeLevelKept: "يتم الاحتفاظ بإعداداته المحفوظة إذا قمت بترقيته مرة أخرى.",
    removeLevelConfirm: "إزالة",
    levelRemoved: "تمت إزالة المستوى الإداري!",
    levelRemoveFailed: "تعذر إزالة المستوى الإداري.",
    // ── user picker filter ──
    filterAll: "الكل",
    filterHasLevel: "لديه مستوى",
    filterCustomSetup: "إعداد مخصص",
    filterNoLevel: "بدون مستوى",
    resultsCount: "نتيجة",
    // ── reassignment warnings (levels mode) ──
    assignMoveWarningTitle: "بعض المستخدمين المحددين ينتمون بالفعل إلى مستوى آخر",
    assignMoveLine: "⚠ سيتم نقل {name} من «{level}»",
  },
  en: {
    selectAll: "Select all",
    deselectAll: "Deselect all",
    includeAllFeatures: "Also enable all features for these pages",
    pageTitle: "Admin Levels Management",
    createAdminLevel: "Create Admin Level",
    refreshPermissions: "Refresh Permissions",
    selectCompany: "Select Company",
    clientName: "Client Name",
    workingCompany: "Working Company",
    selectClient: "Select client...",
    selectCompany2: "Select company...",
    loadAdminLevels: "Load Admin Levels",
    loadDrive: "Load Drive",
    loadingCompanies: "Loading companies...",
    adminLevels: "Admin Levels",
    loading: "Loading...",
    noAdminLevels: "No admin levels found for selected company",
    visibilityControl: "Visibility Control",
    assignEmployees: "Assign Employees",
    modulesFeatures: "Modules & Features",
    addModule: "Add Module",
    noModules: "No modules assigned",
    addFeature: "Add Feature",
    noFeatures: "No features configured",
    name: "Name",
    description: "Description",
    create: "Create",
    cancel: "Cancel",
    save: "Save",
    selectModule: "Select Module",
    selectModulePlaceholder: "-- Select a module --",
    selectFeature: "Select Feature",
    selectFeaturePlaceholder: "-- Select a feature --",
    visibilityControlTitle: "Visibility Control",
    visibilityDesc: "Configure who this admin level can view.",
    searchUsers: "Search users...",
    loadingVisibility: "Loading visibility rules...",
    companies: "Companies",
    noCompanies: "No companies found for this client.",
    departments: "Departments",
    selectAtLeastOne: "Select at least one company.",
    noDepartments: "No departments loaded.",
    departmentTip: "Tip: Selecting departments means all users in those departments.",
    users: "Users (Optional)",
    usersTip: "For specific users only, leave departments unchecked and select users.",
    noUsers: "No users found for current selection.",
    assignToLevel: "Assign Employees to Level",
    assignDesc: "Selecting users here will set their admin level to",
    searchByName: "Search by name/email/department...",
    loadingUsers: "Loading users...",
    saveAssignments: "Save Assignments",
    deleteConfirm: "Are you sure you want to delete this admin level?",
    deleteMessage: "This admin level will be permanently deleted and cannot be undone.",
    deleteLevelBtn: "Delete level",
    assignedUsersCount: "assigned users",
    created: "Admin level created successfully!",
    moduleUpdated: "Module permission updated!",
    featureUpdated: "Feature permission updated!",
    deleted: "Admin level deleted successfully!",
    moduleAdded: "Module added successfully!",
    featureAdded: "Feature added successfully!",
    visibilitySaved: "Visibility rules saved!",
    assignmentsSaved: "Users assigned to level!",
    selectModuleError: "Please select a module",
    selectFeatureError: "Please select a feature",
    namePlaceholder: "e.g., HR Manager",
    descPlaceholder: "Brief description of this admin level",
    welcomeTitle: "Welcome to Admin Levels Management",
    welcomeSubtitle: "Manage roles, permissions, and employee access efficiently",
    infoModalTitle: "Admin Levels Management",
    infoModalDesc: "This page allows administrators to:\n• Create and manage admin levels\n• Assign permissions and features\n• Control visibility settings\n• Assign employees\n• Edit or remove existing configurations",
    // ── per-user permission editor (v2) ──
    usersTab: "Users",
    levelsTab: "Levels",
    teamMembers: "Team members",
    noUsersLoaded: "Load a company to see its users",
    noSearchResults: "No matching users",
    selectUserPrompt: "Select a user to configure their access",
    selectUserHint: "Pick a team member from the list to see and adjust which pages and features they can use.",
    selectLevelPrompt: "Select a level to configure its access",
    selectLevelHint: "Pick a level from the list to see and adjust which pages and features it grants. Changes apply to every user assigned to this level.",
    customSetup: "Custom setup",
    inheritsPrefix: "Inherits",
    noLevelYet: "No level yet",
    pagesTitle: "Pages & permissions",
    changesSaveInstantly: "Changes save instantly",
    stateHidden: "Hidden",
    stateLocked: "Visible · Locked",
    stateFull: "Full Access",
    stateHiddenHint: "The page is removed from the menus entirely.",
    stateLockedHint: "Shown in the menu, but opens a 'no access' screen.",
    stateFullHint: "Opens normally — fine-tune buttons and columns below.",
    featuresButtons: "Buttons",
    featuresSections: "Sections",
    featuresTabs: "Tabs",
    columnsTitle: "Table columns",
    columnsHint: "Filled chip = visible column. Click a column to hide it.",
    noFeaturesForPage: "This page has no fine-grained options.",
    previewTitle: "Live preview",
    webPreview: "Web sidebar",
    mobilePreview: "Mobile preview",
    dashboardLabel: "Dashboard",
    settingsLabel: "Settings",
    lockedTag: "Locked",
    confirmPersonalTitle: "Create a personal configuration?",
    confirmPersonalBefore: "currently belongs to the shared level",
    confirmPersonalAfter: "Continuing will remove this user from that level and switch them to their own personal configuration, copied from it as a starting point.",
    continueBtn: "Continue",
    personalLevelReady: "Personal configuration ready!",
    permissionSaved: "Change saved!",
    permissionFailed: "Couldn't save the change — it was reverted.",
    loadingConfig: "Loading configuration...",
    loadingRegistry: "Loading page list...",
    registryFailed: "Couldn't load the page list.",
    usersFailed: "Couldn't load users.",
    personalLevelFailed: "Couldn't prepare the personal configuration.",
    usersCount: "users",
    configuringFor: "Configuring",
    // ── remove admin level ──
    removeAdminLevelBtn: "Remove admin level",
    removeLevelTitle: "Remove admin level?",
    removeLevelBody: "will lose their admin view entirely and go back to standard access.",
    removeLevelKept: "Their saved configuration is kept if you promote them again.",
    removeLevelConfirm: "Remove",
    levelRemoved: "Admin level removed!",
    levelRemoveFailed: "Couldn't remove the admin level.",
    // ── user picker filter ──
    filterAll: "All",
    filterHasLevel: "Has level",
    filterCustomSetup: "Custom setup",
    filterNoLevel: "No level",
    resultsCount: "results",
    // ── reassignment warnings (levels mode) ──
    assignMoveWarningTitle: "Some selected users already belong to another level",
    assignMoveLine: "⚠ {name} will be moved from '{level}'",
  },
};